import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import {
    FAILURE_ADD_CUSTOMER_PAYMENT_METHOD,
    FAILURE_CUSTOMER_PAYMENT_METHODS,
    FAILURE_CUSTOMER_PAYMENT_METHODS_ADMIN,
    FAILURE_DEACTIVATE_CUSTOMER_PAYMENT_METHOD,
    REQUEST_ADD_CUSTOMER_PAYMENT_METHOD,
    REQUEST_CUSTOMER_PAYMENT_METHODS,
    REQUEST_CUSTOMER_PAYMENT_METHODS_ADMIN,
    REQUEST_DEACTIVATE_CUSTOMER_PAYMENT_METHOD,
    SUCCESS_ADD_CUSTOMER_PAYMENT_METHOD,
    SUCCESS_CUSTOMER_PAYMENT_METHODS,
    SUCCESS_CUSTOMER_PAYMENT_METHODS_ADMIN,
    SUCCESS_DEACTIVATE_CUSTOMER_PAYMENT_METHOD,
} from './actions';

/* Customer Payment Methods */
export function customerPaymentMethodsReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CUSTOMER_PAYMENT_METHODS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CUSTOMER_PAYMENT_METHODS:
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        case FAILURE_CUSTOMER_PAYMENT_METHODS:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });

        case REQUEST_ADD_CUSTOMER_PAYMENT_METHOD:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ADD_CUSTOMER_PAYMENT_METHOD:
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        case FAILURE_ADD_CUSTOMER_PAYMENT_METHOD:
            return _.assign({}, state, { isFetching: false, error: action.error });

        case REQUEST_DEACTIVATE_CUSTOMER_PAYMENT_METHOD:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DEACTIVATE_CUSTOMER_PAYMENT_METHOD:
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        case FAILURE_DEACTIVATE_CUSTOMER_PAYMENT_METHOD:
            return _.assign({}, state, { isFetching: false, error: action.error });

        default:
            return state;
    }
}

/* Admin Customer Paymnent Methods */
export function customerPaymentMethodsAdminReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CUSTOMER_PAYMENT_METHODS_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CUSTOMER_PAYMENT_METHODS_ADMIN:
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        case FAILURE_CUSTOMER_PAYMENT_METHODS_ADMIN:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}
